module.exports = __webpack_public_path__ + "img/8.22e916f5.jpg";